import type { Locale, Localized } from "../types";

type SectionHeaderProps = {
  locale: Locale;
  number: string;
  title: Localized;
  intro?: Localized;
  align?: "left" | "center";
};

export default function SectionHeader({
  locale,
  number,
  title,
  intro,
  align = "left",
}: SectionHeaderProps) {
  return (
    <header className={`section-header ${align === "center" ? "is-centered" : ""}`}>
      <span className="section-number">{number}</span>
      <h2>{title[locale]}</h2>
      {intro ? <p>{intro[locale]}</p> : null}
    </header>
  );
}
